module.exports = __webpack_public_path__ + "img/features-advance.aaa8ca46.svg";